import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { ArrowChevronLeftIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { sortBy } from 'lodash-es';
import { forwardRef } from 'react';
import { CardButton } from './elements/card_button';
import { EventTypeHost } from './elements/event_type_host';
import { Footer } from './elements/footer';
import peopleIconSrc from './elements/people_icon.svg';
import { PopupBody } from './elements/popup_body';
import { Header } from './elements/popup_header';
import { RescheduleFlowModal } from './reschedule_flow_modal';
const sortMemberships = (memberships, originalUserUUID) => sortBy(memberships, membership => {
  if (membership.enabled && membership.userUuid === originalUserUUID) return 1;
  if (membership.enabled) return 2;
  return 3;
});
const containerCss = "c1hu1n4l";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
export const HostPickerPopup = ({
  event,
  eventType,
  invitee,
  isInviteeOnlyReschedule,
  isOpen,
  onClose,
  onBack,
  onReschedule,
  onRescheduleWithHost
}) => {
  const originalHostUUID = event.pageMembers[0].uuid;
  const memberships = eventType.memberships.filter(membership => !event.collectiveMembersUuids.includes(membership.userUuid));
  const sortedMemberships = sortMemberships(memberships, originalHostUUID);
  return <RescheduleFlowModal isOpen={isOpen} onClose={onClose} withCloseButton>
      <Header invitee={invitee} eventType={eventType} isInviteeOnlyReschedule={isInviteeOnlyReschedule} />
      <PopupBody bottomBorder={!!onBack}>
        <Container>
          <BodyText weight="bold">
            {I18n.t('publisher.rescheduling_flow.host_picker_modal.subtitle')}
          </BodyText>
          <CardButton icon={<img src={peopleIconSrc} alt="" aria-hidden />} header={I18n.t('publisher.rescheduling_flow.host_picker_modal.rr_card.header')} body={I18n.t('publisher.rescheduling_flow.host_picker_modal.rr_card.body')} onClick={onReschedule} />
        </Container>
        <Container>
          <BodyText weight="bold" color="muted">
            {I18n.t('publisher.rescheduling_flow.host_picker_modal.subtitle_hosts')}
          </BodyText>
          <div>
            {sortedMemberships.map(membership => <EventTypeHost key={membership.userUuid} membership={membership} isOriginallyAssigned={originalHostUUID === membership.userUuid} onClick={() => onRescheduleWithHost(membership.userUuid)} />)}
          </div>
        </Container>
      </PopupBody>
      {onBack && <Footer>
          <Button decoration="secondary-outline" onClick={onBack}>
            <ArrowChevronLeftIcon />
            {I18n.t('publisher.action.back')}
          </Button>
        </Footer>}
    </RescheduleFlowModal>;
};

require("./host_picker_popup.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./host_picker_popup.js");